// API工具，自动拼接服务器地址
import siteConfig from '../config/site-config.js';

// API基础URL配置 - 使用统一配置
const API_URL = siteConfig.getApiUrl();

/**
 * 本地 CRA 开发时，上传走后端直连，避免 webpack-dev-server 代理弄坏 multipart。
 */
function resolveUploadBaseUrl() {
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, port } = window.location;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    const isCraDev = !port || port === '3000' || port === '3001' || port === '5001';
    if (isLocal && isCraDev) {
      return 'http://127.0.0.1:5000/api';
    }
  }
  return API_URL;
}

function normalizeApiPath(path) {
  let cleanPath = path || '';
  if (cleanPath.startsWith('/api/')) {
    cleanPath = cleanPath.substring(4);
  } else if (!cleanPath.startsWith('/')) {
    cleanPath = '/' + cleanPath;
  }
  return cleanPath;
}

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    ...(options.headers || {})
  };
  // FormData 必须由浏览器自动带 multipart boundary，不能手写 application/json
  if (isFormData) {
    delete headers['Content-Type'];
    delete headers['content-type'];
  } else if (headers['Content-Type'] == null && headers['content-type'] == null) {
    headers['Content-Type'] = 'application/json';
  }
  if (token) headers.Authorization = `Bearer ${token}`;

  const cleanPath = normalizeApiPath(path);
  const fullUrl = `${API_URL}${cleanPath}`;
  console.log('API请求:', { url: fullUrl, method: options.method || 'GET', formData: isFormData });

  // FormData：不要把可能含 Content-Type 的 headers 对象传进 fetch
  if (isFormData) {
    const uploadHeaders = {};
    if (token) uploadHeaders.Authorization = `Bearer ${token}`;
    return fetch(fullUrl, { ...options, headers: uploadHeaders });
  }

  return fetch(fullUrl, { ...options, headers });
}

/**
 * 专用文件上传：永不设置 Content-Type，本地开发直连后端 5000。
 */
export async function apiUploadFile(path, formData, options = {}) {
  const token = localStorage.getItem('token');
  const cleanPath = normalizeApiPath(path);
  const fullUrl = `${resolveUploadBaseUrl()}${cleanPath}`;
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  console.log('API上传:', { url: fullUrl, method: options.method || 'POST' });
  return fetch(fullUrl, {
    method: options.method || 'POST',
    body: formData,
    headers,
    credentials: options.credentials
  });
}
